function getHandicap (selection) {
  var h
  if (selection) {
    h = typeof selection.currenthandicap !== 'undefined' ? selection.currenthandicap
      : typeof selection.currentmatchhandicap !== 'undefined' ? selection.currentmatchhandicap
        : typeof selection.Handicap !== 'undefined' ? selection.Handicap : null
    h = JSON.parse(h)
  }
  // console.log('getHandicap from', selection, ':', h)
  return h
}

function formatHandicap (selection) {
  // console.log('formatHandicap:', selection)
  var h = getHandicap(selection)
//        var h = selection.currenthandicap && !isNaN(selection.currenthandicap) ? parseFloat(selection.currenthandicap) : ''
  if (typeof h !== 'number') {
    return ''
  }
  if (h === 0 && window.ctsautoconf.SHOW_ZERO_HCP_AS_PK) {
    return 'PK'
  }
  var hadvalue = selection.hadvalue || selection.HAD || selection.HADValue
  if (h !== '' && typeof h === 'number') {
    if (hadvalue === 'A') {
      if (h) {
        h *= -1
      }
    }
    if (h >= 0 && ['H', 'A', 'D'].includes(hadvalue)) {
      h = '+' + h
    }
  }
  return h
}

function getTeaserHcp (hcp, teaserSelection) {
  let hadvalue = teaserSelection.hadvalue || teaserSelection.HAD || teaserSelection.HADValue
  let spread = teaserSelection.spread ? teaserSelection.spread * 1 : 0
  let hcpT = hcp + spread * (['A', 'O'].includes(hadvalue) ? -1 : 1)
  return hcpT
}

export default {
  getHandicap,
  formatHandicap,
  getTeaserHcp
}



// WEBPACK FOOTER //
// ./src/library/hcpFormat/index.js